import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/shared/api.service';
import * as moment from 'moment';
import { CONSTANTS } from 'app/constants';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { OrdersService } from 'app/modules/store/store.service';
import { ApiOrderService } from 'app/shared/api.store.service';
import { CreateOrderSessionParamdDTO, NewOrderSessionTokenDTO, OrderSessionTokenDTO } from 'app/modules/models/order-session-create.dto';
import { environment } from 'environments/environment';
import { UtilsService } from 'app/shared/utils.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

const OrderSessionKey = CONSTANTS.OrderSessionTokenKey

@Injectable({providedIn: 'root'})

export class OrderHandleSessionService {    

    _currencyCode: BehaviorSubject<string> =  new BehaviorSubject('GTQ')

    constructor(
        private orderServive: ApiOrderService,
        private matDialog: MatDialog,
        private _fuseConfirmationService: FuseConfirmationService,
        private _utils: UtilsService,
        private route: Router
    ) 
    {
        
    }

    /** PUBLIC PROPERTIES */

    get orderSession() {
        return  sessionStorage.getItem(OrderSessionKey) ?? null;
    }

    get timeRemaining(){
        if (this.orderSession) {
            const token_expirdDate = AuthUtils._getTokenExpirationDate(this.orderSession)
            const difference =  moment(token_expirdDate).diff(moment())
            return moment(difference).format('mm:ss')
        } else {
            return '0'
        }

    }

    set orderSession(orderSessionToken: string) {
        sessionStorage.setItem(OrderSessionKey, orderSessionToken)
    }

    get customer_uuid() {
        const decoded = this._utils.decodeToken(this.orderSession)
        return decoded.customer_uuid ?? 'S/D'
    }

    get order_uuid() {
        const decoded = this._utils.decodeToken(this.orderSession)
        return decoded.order_uuid ?? 'S/D'
    }
    
    get hold_token() {
        const decoded = this._utils.decodeToken(this.orderSession)
        return decoded.hold_token ?? ''
    }

    get seats_workspace_public_key() {
        const decoded = this._utils.decodeToken(this.orderSession)
        return decoded.seats_workspace_public_key ?? ''
    }

    // currency
    get currencyCode() {
        return this._currencyCode.getValue() ??  'GTQ'
    }

    /***
     * PUBLIC METHODS
     */

    
    expireOrder(order_uuid): Promise<any> {
        return new Promise((resolve, reject) => {
            const url = `/order/expire/${order_uuid}`
            this.orderServive.PutMethod(url, {}, {}, 'No se pudo expirar la orden')
                .subscribe(response => {
                    resolve(true)
                }, error => {
                    resolve(true)
                })
        })

        
    }


    /** */
    IsExpiredSession(token): boolean {
       return AuthUtils.isTokenExpired(token)
    }
    
    /**
     * Open a modal when token is expired
     */
    async openExpiredModal() {

        // expire order
        await this.expireOrder(this.order_uuid)

        // open modal
        const dialog = this._fuseConfirmationService.open(
            {
                title: 'La orden ha expirado',
                message:'¿Desea comenzar una nueva orden?',
                icon: {
                    show: true,
                    name: 'info'
                },
                actions: {
                    confirm: { label: 'Comenzar' },
                    cancel:  { label: 'Abandonar Tienda' }
                }
            }
        );
        
        dialog.afterClosed().subscribe(async (closed) => {

            // empty session storage
            sessionStorage.clear()
            // api to cancell orden
            if (closed === 'confirmed') {
                window.location.reload()
            }
            if (closed === 'cancelled') {
                window.location.href = `${window.location.protocol}//${window.location.host}`
            }
        })
    }


    /**
     * 
     * @param params CreateOrderSessionParamdDTO  
     * @returns a JWT order session token
     */
    handleOrderSession(params: CreateOrderSessionParamdDTO): Promise<string> {
        return new Promise( async (resolve, reject) => {

            // clear other sessions 
            sessionStorage.clear()

            // draft new session
            this.draftNewOrderSession(params)
                .then(token => {
                    resolve(token)
                })
                .catch(error => {
                    // if error  redirect to index page
                    
                    const modal = this._fuseConfirmationService.open( { 
                        message:  'No es posible realizar la compra en estos momentos, intente más tarde.',
                        actions: {
                            confirm:    { show: true, label: 'Aceptar'},
                            cancel:     {show: false}
                        }
                    })
                    modal.afterClosed().subscribe(() => {
                        this.route.navigateByUrl('/')
                    })

                })
        })
    }



       

    /**
     * 
     * @param params CreateOrderSessionParamdDTO   for booking details. in memory session
     * @returns a JWT order session token
     */
    handleOrderSessionBookingV3(params: CreateOrderSessionParamdDTO): Promise<string> {
        return new Promise( async (resolve, reject) => {

            // clear other sessions 
            sessionStorage.clear()

            // draft new session
            this.draftNewOrderSessionBookingV3(params)
                .then(token => {
                    resolve(token)
                })
                .catch(error => {
                    // if error  redirect to index page
                    
                    const modal = this._fuseConfirmationService.open( { 
                        message:  'No es posible realizar la compra en estos momentos, intente más tarde.',
                        actions: {
                            confirm:    { show: true, label: 'Aceptar'},
                            cancel:     {show: false}
                        }
                    })
                    modal.afterClosed().subscribe(() => {
                        this.route.navigateByUrl('/')
                    })

                })
        })
    }


    /***
     * PRIVATE METHODS
     */


    /**
     * 
     * @param body CreateOrderSessionParamdDTO
     * @returns private method to create a new order session ,  whe the api response with token it will be saved on a session storage key
     */
    private draftNewOrderSession(body: CreateOrderSessionParamdDTO): Promise<string>{
       
        // create new draft order  
        return new Promise((resolve, reject) => {
            const url =`/order-session/create-token`
            this.orderServive.PostMethod(url, body,  {}, '')
                .subscribe((response: NewOrderSessionTokenDTO) => {
                    if (response && response.token) {
                        this.orderSession = response.token
                        // currency
                        const currency = response.new_order.organization?.country.value_3 ?? 'GTQ'
                        this._currencyCode.next(currency)
                        resolve(response.token)
                    }
                }, error => {
                    reject(error)
                })
        })
    }



        /**
     * 
     * @param body CreateOrderSessionParamdDTO
     * @returns private method to create a new order session ,  whe the api response with token it will be saved on a session storage key
     */
    private draftNewOrderSessionBookingV3(body: CreateOrderSessionParamdDTO): Promise<string>{
       
        // create new draft order  
        return new Promise((resolve, reject) => {
            const url =`/order-session/create-token/v3`
            this.orderServive.PostMethod(url, body,  {}, '')
                .subscribe((response: NewOrderSessionTokenDTO) => {
                    if (response && response.token) {
                        this.orderSession = response.token
                        // currency
                        const currency = response.new_order.organization?.country.value_3 ?? 'GTQ'
                        this._currencyCode.next(currency)
                        resolve(response.token)
                    }
                }, error => {
                    reject(error)
                })
        })
    }


    /**
     * 
     * @returns Private funciton , se deshabiltia temporalmente
     */
    private hasTokenValid(): boolean {
        const token =  this.orderSession
        if (token) {
            return  !this.IsExpiredSession(token)
        } 
        else {
            return false
        }
    }

}
